import * as React from 'react'
import { useSearchParams } from 'react-router-dom'
import useBasePage from 'app/shared/hooks/base-page.hook'
import { useLazySelectDep0301Query } from 'app/core/services/prd/man/man.service'
import {
    useLazySelectCom0207Query,
    useLazySelectCom0402Query,
    useLazySelectCom0403Query,
} from 'app/core/services/com/com.service'

import { useDispatch } from 'react-redux'
import {
    initIssueCardInfo,
    issueCardInfo,
} from 'app/core/models/slice/crd/issueCardInfo'
import {
    clearJoinProduct,
    setHomeJoinProductIf,
} from 'app/core/slices/product/joinProduct.slice'
import { isNull, isEmpty } from 'app/shared/utils/comUtil'
import { setHomeIssueCardInfo } from 'app/core/slices/product/issueCardInfoslice.slice'
import { clear, setCusInfoObArr, setCusInfoArr } from 'app/core/slices/user/user.slice'
import {
    joinProductIf,
    initJoinProductIf,
} from 'app/core/models/slice/prd/joinProduct'
import { useProductJoin } from 'app/shared/hooks/util/product.hook'
import {
    clearProductMain,
    setProductMainObArr,
} from 'app/core/slices/product/productMain.slice'
import { Product } from 'app/pages/prd/man/PRDMAN0101'
import _ from 'lodash'
import { showAlert } from 'app/shared/utils/util'
import { useNarasarang } from 'app/shared/hooks/util/narasarang.hook'

/*======================================================================
 * @ 업무설명 : 공통 - 외부 진입 링크 관리 GateWay
 * @ 파 일 명 : /app/pages/mai/app/MAIAPP0102.tsx
 * @ 관련API  : com0207 : 제휴처코드 유효성체크  모바일 브랜치 : 03
 *              dep0301 : 상품목록조회
 * @ ASIS : /UIBMAO_CUBE/nfrc/combo.xml
 *======================================================================
 * 번호  작업자           작업일         변경내용
 *======================================================================
 * 1     한중근(S27239)   2025.06.11    최초작성
 *======================================================================
 */

const MAIAPP0102: React.FC = () => {
    const router = useBasePage()
	const { setJoinProductObArr } = useProductJoin()
    const dispatch = useDispatch()
    const [searchParams] = useSearchParams()

    let vAcd = searchParams?.get('acd') ?? '03' //제휴사코드
    const menuId = searchParams?.get('menuId') ?? '' // to-be : 메뉴ID
    const vApcd = searchParams?.get('apcd') ?? '' //상품 코드
    const vDt = searchParams?.get('dt') ?? '' //상품상세로이동여부

    /* 개인신용정보동의서(4번동의서)용 파라미터 추가 */
    const brcd = searchParams?.get('mrknCretBrcd') ?? '' //부점코드
    const emn = searchParams?.get('mrknCretEmn') ?? '' //직원번호
    const cbinqObjtCd = searchParams?.get('CBINQ_OBJT_CD') ?? '' // 조회목적코드

    let mrknCretBrcd = searchParams?.get('mrknCretBrcd')
        ? _.padStart(searchParams?.get('mrknCretBrcd'), 4, '0')
        : '' //관리부점코드
    const mrknCretEmn = searchParams?.get('mrknCretEmn') ?? '' //권유직원번호

    /* 군간부 배우자 비대면 동의용 파라미터 추가 */
    const csn = searchParams?.get('CSN') ?? '' //전행고객번호
    const gubun = searchParams?.get('GUBUN') ?? '' //상품구분코드

    const eventId = searchParams?.get('evntId') ?? '' // 이벤트id 이벤트상세 페이지 이동
	const tid = searchParams?.get('tid') ?? '' //토스앱을 통한 주택청약저축 tid(거래번호)

    let nstationSubparam = searchParams?.get('nst_subparam') ?? '' // CPA 로 들어올때
    let nstationMode = searchParams?.get('nst_mode') ?? '' // CPA 로 들어올때

    /** 나라사랑카드 3기 사전신청 */
    const targetKey = searchParams?.get('targetKey') ?? ''

    let grpcd = '' //비대면상품구분코드
    let catlDcd = '103' //상품몰 상품 카테고리코드

    const [fetchCom0207] = useLazySelectCom0207Query() // 제휴처 확인
    const resultDep0301 = React.useRef(null) //  상품 목록
    const [fetch0301] = useLazySelectDep0301Query()
    const [fetch0402, { data: fetch0402Data }] = useLazySelectCom0402Query()
    const [fetch0403, { data: fetch0403Data }] = useLazySelectCom0403Query()

    const joinProductIfOb = React.useRef<joinProductIf>(initJoinProductIf)
    const issueCardInfoOb = React.useRef<issueCardInfo>(initIssueCardInfo)

	const narasarangHook = useNarasarang()
	const cpnEvntAlplDcd = [ // 이벤트진행중인 제휴처코드
		'03', // IBK(당행) - 청년미래적금 리부트 이벤트(2026.07.24 추가)
		'43', // 삼성전자 패밀리몰(우대금리쿠폰 반영)
		'44', // GS리테일(우대금리쿠폰 반영)
		'45', // 메가스터디(우대금리쿠폰 반영)
	]
	const cpnActEvntId = [ // 진행중인 이벤트ID
		'2026071303', // IBK(당행) 이벤트ID - 청년미래적금 리부트 이벤트
		'2026051106', // 삼성전자제휴 이벤트ID
		'2026060208', // GS리테일제휴 이벤트ID
		'2026060104', // 메가스터디 이벤트ID
	]
	const cpnActEvntPdcd = [ // 이벤트진행중인 상품코드
		'01211210113',	//IBK D-Day 적금
	]

	const mapEvent = { // 이벤트ID-제휴처 매핑
		'2026071303' : '03',
		'2026051106' : '43', 
		'2026060208' : '44',
		'2026060104' : '45',
	}
	
    const isPrdInfo = React.useRef<Product>({
        PDF_PTRN_NM: '',
        NFCH_PRSA_YN: '',
        PDLN_CD: '',
        ALL_PDCD: '',
        SALE_NBI_6: '',
        PRCF_BASE_CD: '',
        PDGR_CD: '',
        WHBN_VCD: '',
        JNNG_CHNL_INFO_CON_2: '',
        SALE_NBI_3: '',
        JNNG_CHNL_INFO_CON_1: '',
        SALE_NBI_1: '',
        NFCH_PRCF_GRP_CD_NM: '',
        RLTN_BRCD: '',
        PDF_IMG_URL_ADR: '',
        CCAL_CD: '',
        NFCH_PDF_MXMM_PRNL_INR: '',
        SALE_NBI_12: '',
        MXAP_ABL_INR: '',
        CARD_BRCO_DSNC_NM_1: '',
        JNNG_TRM: '',
        CARD_BRCO_DSNC_NM_2: '',
        LOIN_DSNC_NM: '',
        NFCH_PRCF_GRP_CD: '',
        NFCH_PDF_MXMM_AGRM_INR: '',
        PDF_INTCD: '',
        JNNG_LINK_URL_ADR: '',
        PDCD: '',
        PDTM_CD: '',
        NFCH_OFR_PDM: '',
        PDF_RMRK_CON: '',
        PDF_PRMR_CON: '',
    })
    const brcdCheck = async () => {
        const result = await fetch0403({
            brcd: mrknCretBrcd,
            mngmBrcd: '',
        })

        if (result.isError) {
            router.replacePage('/M0000')
            return false
        } else {
            const brncDcd = result.data.brncDcd
            if (
                !_.isEmpty(brncDcd) &&
                (brncDcd === '1' ||
                    brncDcd === '2' ||
                    brncDcd === '3' ||
                    brncDcd === '4')
            ) {
                dispatch(
                    setCusInfoObArr({
                        mrknCretBrcd: mrknCretBrcd,
                        bankBrncNm: result?.data?.krnBrm,
                    })
                )
            } else {
				//4번동의서 수집 거래(M0026) -> 본점도 사용가능하도록 변경 부점코드 검증부 생략
				if(!_.isEmpty(brncDcd)&& menuId ==='M0026'){
				    dispatch(
				        setCusInfoObArr({
				            mrknCretBrcd: mrknCretBrcd,
				            bankBrncNm: result?.data?.krnBrm,
				        })
				    )   
				} else{
					router.goHome(true)
					return false			
				}
            }
        }

        return true
    }

    const emnCheck = async () => {
        const result = await fetch0402({
            selType: '2',
            selMemo: mrknCretEmn,
        })

        if (result.isError) {
            router.replacePage('/NotFound')
            return false
        } else {
            if ((result.data?.empList ?? []).length === 0) {
                router.replacePage('/M0000')
                return false
            } else {
                dispatch(
                    setCusInfoObArr({
                        mrknCretBrcd: result?.data.empList[0].brcd,
                        bankBrncNm: result?.data.empList[0].bankBrncNm,
                        mrknCretEmn: mrknCretEmn,
                        emplNm: result?.data.empList[0].emplNm,
                    })
                )
            }
        }

        return true
    }

    const setCusInfo = () => {
        dispatch(
            setCusInfoObArr({
                cbinqObjtCd: cbinqObjtCd,
                brcd: brcd,
                emn: emn,
                // mrknCretBrcd: mrknCretBrcd,
                // mrknCretEmn: mrknCretEmn,
                csn: csn,
                gubun: gubun,
                evntId: eventId,
                alplDcd: vAcd,
                acd: vAcd,
            })
        )
    }

    const errorGoNotFound = () => {
        dispatch(clear())
        router.replacePage('/NotFound')
    }

    /**
     ** to-be : store: state 상품 정보 : joinProduct   사용자 정보  : user.cusInfo
     ** 각 화면에서는 brcd 부점코드와 emn 추천직원번호 를 확인해서  gateway 페이지에서 왔다는 것을 확인 가능
     **/

    // As-Is : goComboAth
    const init = async () => {
        localStorage.removeItem('NSTATION_SUBPARAM')
        localStorage.removeItem('NSTATION_MODE')
		narasarangHook.clearNarasarang()
        //user slice clear
        dispatch(clear())
        dispatch(
            setCusInfoObArr({
                isGwEnter: true,
            })
        )

        //제휴처-영업점인데
        // 1. 권유직원정보가 있고 6자리가 아니면 오류
        // 2. 권유직원, 지점정보가 둘다 없으면 오류
        if (vAcd === '01') {
            if (
                (mrknCretEmn && mrknCretEmn.length !== 6 && !mrknCretBrcd) ||
                (!mrknCretEmn && !mrknCretBrcd)
            ) {
                errorGoNotFound()
                return
            }
        }

        // 제휴처-영업점이 아닌데
        // 1. 권유직원, 지점정보가 있으면 오류
        // if (vAcd !== '01' && (mrknCretEmn || mrknCretBrcd)) {
        //     router.replacePage('/NotFound')
        //     return
        // }

        //제휴처 코드 유효성체크
        const com0207Result = await fetchCom0207({
            alplDcd: isNull(vAcd) ? '03' : vAcd,
        })

        if (com0207Result.isSuccess) {
            if (vAcd !== com0207Result.data.alplDcd) {
                showAlert({
                    msg: '잘못된 유입경로입니다.<br>IBK 모바일브랜치 메인 화면으로 이동합니다.',
                    onConfirm: errorGoNotFound,
                })
                return
            }
            vAcd = com0207Result.data.alplDcd
        } else {
            vAcd = '03'
        }
		
		// 제휴처-이벤트ID 유효성 체크
		if (!isEmpty(eventId)) {
			
			// 진행중인 (금리우대쿠폰) 이벤트와 제휴처에 대한 제휴처-이벤트ID 유효성 검증
			// 당행(제휴처코드 03) 진행이벤트 중 금리우대쿠폰 외 모바일브랜치 메인배너 / 상품몰 배너를 통해 진입하는 이벤트인 경우도, 
			// gateway 접속 URL 내 evntID를 포함하고 있음.
			// 아래 제휴처-이벤트ID는 우대쿠폰 서비스에 한하여, 검증하도록 일부 수정(2026.07.24) => 우선순위 1 : 해당 이벤트ID가 금리우대쿠폰이벤트 ID여부 검증
			
			
					// 쿠폰이벤트 한정,  제휴처-이벤트ID 유효성 검증
					// 우대쿠폰 이벤트ID 에 해당하는 경우
					if (cpnActEvntId.includes(eventId)) {
						// 우대쿠폰 이벤트 진행 제휴코드에 해당하는 경우,
			if (cpnEvntAlplDcd.includes(vAcd)) {
							// 제휴처코드와 이벤트ID간 정상 mapping 검증 확인
				if (mapEvent[eventId] != vAcd) {
					showAlert({
						msg: '잘못된 유입경로입니다.<br>IBK 모바일브랜치 메인 화면으로 이동합니다.',
						onConfirm: () => { 
							dispatch(setCusInfoArr([{ key  :'evntId', value: ''}]))
							router.goHome() 
						},
					})

					return
				}	
			}
						else {	// 쿠폰이벤트ID는 정상이나, 제휴처코드 매핑이 잘못된 경우,
					showAlert({
						msg: '잘못된 유입경로입니다.<br>IBK 모바일브랜치 메인 화면으로 이동합니다.',
						onConfirm: () => { 
							dispatch(setCusInfoArr([{ key  :'evntId', value: ''}]))
							router.goHome() 
						},
					})

					return
				}	                       
			}
		}
		// tid 존재시 토스 제휴처 확인
		if (!isEmpty(tid)) {
			if(vAcd == '16'){
				setJoinProductObArr({ lgnLnkId: tid })
			}else{
				showAlert({
					msg: '잘못된 유입경로입니다.<br>IBK 모바일브랜치 메인 화면으로 이동합니다.',
					onConfirm: () => { 
						router.goHome() 
					}, 
				})
				return
			}
		}

		
        // 상세로 온 지점코드 세팅
        if (!isEmpty(mrknCretBrcd)) {
            const result = await brcdCheck()
            if (!result) return
        }

        // 상세로 온 권유직원 세팅
        if (!isEmpty(mrknCretEmn)) {
            const result = await emnCheck()
            if (!result) return
        }

        if (isNull(menuId)) {
            router.replacePage('/')
        } else {
            dispatch(clearProductMain())

            // 상품상세 menuId 로  grpcd 세팅

            if (menuId === 'M0036') {
                grpcd = '302'
            } else if (menuId === 'M0037') {
                grpcd = '301'
            } else if (menuId === 'M0033') {
                grpcd = '103'
            } else if (menuId === 'M0034') {
                grpcd = '101'
            } else if (menuId === 'M0035') {
                grpcd = '102'
            } else if (menuId === 'M0038') {
                grpcd = '600'
            } else if (menuId === 'M0039') {
                grpcd = '400'
            } else if (menuId === 'M0015') {
                grpcd = 'A00'
            } else if (menuId === 'M0019') {
                grpcd = 'frx'
            } else {
                grpcd = ''
            }

            /*
            상품몰 - 상품 카테고리코드 세팅
            입출금 : '103'
            적금∙청약 : '101'
            예금∙중금채 : '102'
            체크카드 : '302'
            신용카드 : '301'
            대출 : '600'
            보험 : '400'
            퇴직연금(IRP) : 'A00'
            ISA : '800'
            펀드 : '500'
            */
            if (menuId === 'M0008') {
                catlDcd = '103'
            } else if (menuId === 'M0009') {
                catlDcd = '101'
            } else if (menuId === 'M0010') {
                catlDcd = '102'
            } else if (menuId === 'M0011') {
                catlDcd = '302'
            } else if (menuId === 'M0012') {
                catlDcd = '301'
            } else if (menuId === 'M0013') {
                catlDcd = '600'
            } else if (menuId === 'M0014') {
                catlDcd = '400'
            } else if (menuId === 'M0015') {
                catlDcd = 'A00'
            } else if (menuId === 'M0016') {
                catlDcd = '800'
            } else if (menuId === 'M0017') {
                catlDcd = '500'
            }

            dispatch(
                setProductMainObArr({
                    catlDcd: catlDcd,
                    sortNam: '추천순',
                    tabviewAllYn: false,
                })
            )

            if (menuId === 'M0026') {
                /*  화면명 : 개인신용정보동의서(4번동의서)   */
                if (
                    //필수 파라미터가 비어있을경우
                    isNull(mrknCretBrcd) ||
                    isNull(mrknCretEmn) ||
                    isNull(cbinqObjtCd)
                ) {
                    errorGoNotFound()
                } else {
                    setCusInfo()
                    router.replacePage('/M0026')
                }
            } else if (menuId === 'M0030') {
                /*  화면명 : 군간부 배우자 비대면 동의 동의 내용안내  */
                if (
                    //필수 파라미터가 비어있을경우
                    isNull(csn) ||
                    isNull(mrknCretEmn) ||
                    isNull(gubun)
                ) {
                    errorGoNotFound()
                } else {
                    setCusInfo()
                    router.replacePage('/M0030')
                }
            } else if (menuId === 'M0042') {
                /*  화면명 : 공공마이데이터 무방문 동의  */

                setCusInfo()
                router.replacePage('/M0042')
            } else if (menuId === 'M0053') {
                /*  화면명 : IBK나라사랑카드 사전신청  */

                if (isEmpty(targetKey)) {
                    errorGoNotFound()
                    return
                }

                setCusInfo()
                router.replacePageWithData('/M0053', { targetKey: targetKey })
            } else if (
                /** 상품 상세 page*/
                menuId === 'M0033' ||
                menuId === 'M0034' ||
                menuId === 'M0035' ||
                menuId === 'M0036' ||
                menuId === 'M0037' ||
                menuId === 'M0038' ||
                menuId === 'M0039'
            ) {
                // 유입 상품 체크
                const result = await checkComingPrdInfo()
                if (result) {
                    let vAcdUrl = '' //0.제휴처- 본인인증으로
                    if (vAcd === '02') {
                        // 1.메인으로
                        vAcdUrl = '/M0000'
                    } else {
                        vAcdUrl = '/' + menuId
                    }

                    //Web CPA 계약 종료 시 관련 코드 삭제
                    //Web CPA 스크립트 관련 파라미터 전달
                    //2025.03.20 개인입출통장 파라미터 추가
					// IBK주거래생활금융통장(01111020069)
					// IBK개인입출통장(01111020006)
					// IBK든든한통장(01111010084)
					// IBK랜덤게임적금(01211210133)
					// IBK생계비계좌(01111010085) 
                    if (
                        (vAcd === '38' &&
                            grpcd === '103' &&
                            vApcd === '01111020069') ||
                        (vAcd === '38' &&
                            grpcd === '103' &&
                            vApcd === '01111020006') ||
						(vAcd === '38' &&
							grpcd === '103' &&
							vApcd === '01111010084') ||
						(vAcd === '38' &&
							grpcd === '103' &&
							vApcd === '01211210133') ||
						(vAcd === '38' &&
							grpcd === '103' &&
							vApcd === '01111010085') ||
						(vAcd === '21' &&
							grpcd === '103' &&
							vApcd === '01111020006') ||
						(vAcd === '21' &&
							grpcd === '103' &&
							vApcd === '01111010084')
                    ) {
                        if (nstationSubparam) {
                            localStorage.setItem(
                                'NSTATION_SUBPARAM',
                                decodeURIComponent(nstationSubparam)
                            )
                        }
                        if (nstationMode) {
                            localStorage.setItem(
                                'NSTATION_MODE',
                                decodeURIComponent(nstationMode)
                            )
                        }
                    }
                    setCusInfo()
                    // 상세page cusInfo 한번 더 저장
                    dispatch(
                        setCusInfoObArr({
                            alplDcd: vAcd,
                            grpcd: grpcd,
                            apcd: vApcd,
                            acd: vAcd,
                            nstSubparam: nstationSubparam,
                        })
                    )

                    isPrdInfo.current.ALL_PDCD = vApcd
                    isPrdInfo.current.PDLN_CD = vApcd.substring(0, 2)
                    isPrdInfo.current.PDGR_CD = vApcd.substring(2, 4)
                    isPrdInfo.current.PDTM_CD = vApcd.substring(4, 7)
                    isPrdInfo.current.PDCD = vApcd.substring(7, vApcd.length)
                    isPrdInfo.current.NFCH_PRCF_GRP_CD = grpcd

                    router.replacePageWithData(vAcdUrl, isPrdInfo.current)
                } else {
                    errorGoNotFound()
                }

                // 이벤트 상세 페이지
            } else if (menuId === 'M0040') {
                if (isNull(eventId)) {
                    errorGoNotFound()
                } else {
                    setCusInfo()
                    // cusInfo에 evntId 있음 화면에서 꺼내쓰기
                    router.replacePage('/' + menuId)
                }

                // 영업점메인
            } else if (menuId === 'M0028') {
                if (isEmpty(mrknCretBrcd)) {
                    if (!isEmpty(mrknCretEmn)) {
                        fetch0402({
                            selType: '2',
                            selMemo: mrknCretEmn,
                        })
                        // cusInfo dispatch
                        dispatch(
                            setCusInfoObArr({
                                mrknCretEmn: mrknCretEmn,
                            })
                        )
                        setCusInfo()
                        router.replacePage('/' + menuId)
                    } else {
                        router.replacePage('/M0000')
                    }
                } else {
                    setCusInfo()
                    router.replacePage('/' + menuId)
                }
                // 나머지 page
            } else {
                setCusInfo()
                router.replacePageWithData(
                    '/' + menuId,
                    Object.fromEntries(searchParams.entries())
                )
            }
        }
    }

    /*
    상품리스트와 카드일떄 학생 여부 확인
    As-Is : prd_inf_010101_8  scwin.checkComingPrdInfo() 
    to-be : /uib/mao/prd/dep/dep03/dep0301)
    */
    const checkComingPrdInfo = async (): Promise<boolean> => {
        /*
        101: 적금식
        102: 예금·중금채
        103: 입출식
        302: 체크카드
        301: 신용카드
        600: 대출
        */
        //let checkPrdList = ''
        let vPrdList = ''

        if (
            grpcd === '101' ||
            grpcd === '102' ||
            grpcd === '103' ||
            grpcd === '301' ||
            grpcd === '302' ||
            grpcd === '600'
        ) {
            // 조회
            resultDep0301.current = await fetch0301({
                nfchPrcfGrpCd: grpcd,
                nfchPdrcTcd: '',
            })
            resultDep0301.current?.data?.prdList.map((item, index) => {
                vPrdList =
                    vPrdList +
                    item.allPdcd +
                    (resultDep0301.current?.data?.prdList.length === index - 1
                        ? ''
                        : ',')

                if (item.allPdcd === vApcd) {
                    joinProductIfOb.current.allPdcd = vApcd
                    joinProductIfOb.current.pdlnCd = vApcd.substring(0, 2)
                    joinProductIfOb.current.pdgrCd = vApcd.substring(2, 4)
                    joinProductIfOb.current.pdtmCd = vApcd.substring(4, 7)
                    joinProductIfOb.current.pdcd = vApcd.substring(7, 11)
                    joinProductIfOb.current.ccalCd = item.ccalCd
                    joinProductIfOb.current.pdm = item.nfchOfrPdm
                    joinProductIfOb.current.nfchOfrPdm = item.nfchOfrPdm
                    joinProductIfOb.current.nfchPrcfGrpCd = grpcd
                    joinProductIfOb.current.pdfIntcd = item.pdfIntcd
                    joinProductIfOb.current.whbnVcd = item.whbnVcd
                    joinProductIfOb.current.nfchPrcfGrpCdNm =
                        item.nfchPrcfGrpCdNm
                    joinProductIfOb.current.cardBrcoDsncNm = item.cardBrcoDsncNm
                    joinProductIfOb.current.pdfImgUrlAdr = item.pdfImgUrlAdr
                    joinProductIfOb.current.pdfPrmrCon = item.pdfPrmrCon
                    joinProductIfOb.current.pdfRmrkCon = item.pdfRmrkCon

                    if (grpcd === '302' || grpcd === '301') {
                        if (item.prcfBaseCd === 'F') {
                            issueCardInfoOb.current.studentCardYn = 'Y'
                        } else {
                            issueCardInfoOb.current.studentCardYn = 'N'
                        }

                        issueCardInfoOb.current.pdlnCd = vApcd.substring(0, 2)
                        issueCardInfoOb.current.pdgrCd = vApcd.substring(2, 4)
                        issueCardInfoOb.current.newCard = '60'
                    }
                }
            })
            //상품정보 store 저장
            dispatch(setHomeJoinProductIf(joinProductIfOb.current))
            dispatch(setHomeIssueCardInfo(issueCardInfoOb.current))
        }

        // 상품목록에 있을 경우만 true
        if (vPrdList.split(',').includes(vApcd)) {
            return true
        } else {
            dispatch(clearJoinProduct())
            return false
        }
    }

    // 0. 진입
    React.useEffect(() => {
        init()
    }, [])

    return <></>
}

export default MAIAPP0102
